import { render, staticRenderFns } from "./MaterialSection.vue?vue&type=template&id=4dde5e7a"
import script from "./MaterialSection.vue?vue&type=script&lang=js"
export * from "./MaterialSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports